import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { PermittedTask } from "./auth.store";

export type Task = PermittedTask;

interface TaskState {
  permittedTasks: Task[];
  roleTaskIds: string[];
  selectedTasks: Task[];
  hasSelectedTasks: boolean;
  setPermittedTasks: (tasks: Task[]) => void;
  setRoleTaskIds: (ids: string[]) => void;
  setSelectedTasks: (tasks: Task[]) => void;
  clearTaskSelection: () => void;
}

export const useTaskStore = create<TaskState>()(
  persist(
    (set) => ({
      permittedTasks: [],
      roleTaskIds: [],
      selectedTasks: [],
      hasSelectedTasks: false,
      setPermittedTasks: (tasks) => set({ permittedTasks: tasks }),
      setRoleTaskIds: (ids) => set({ roleTaskIds: ids }),
      setSelectedTasks: (tasks) =>
        set({
          selectedTasks: tasks,
          hasSelectedTasks: tasks.length > 0,
        }),
      clearTaskSelection: () =>
        set({
          permittedTasks: [],
          roleTaskIds: [],
          selectedTasks: [],
          hasSelectedTasks: false,
        }),
    }),
    {
      name: "task-storage",
      partialize: (state) => ({
        permittedTasks: state.permittedTasks,
        roleTaskIds: state.roleTaskIds,
        selectedTasks: state.selectedTasks,
        hasSelectedTasks: state.hasSelectedTasks,
      }),
    }
  )
);
